import { useEffect, useRef } from 'react';
import { CATCH_UP_END_MS, CATCH_UP_STEP_MS } from './replayModes';

/**
 * Catching up plays itself: a step forward every little while, and after the last new move, `onDone` (the live game).
 */
export default function useCatchUp(replay, on, onDone) {
  // The latest step and onDone, without restarting the timer each render.
  const latest = useRef({ step: replay.step, onDone });
  latest.current = { step: replay.step, onDone };
  const { entries, index } = replay;

  useEffect(() => {
    if (!on || !entries || index === null) {
      return undefined;
    }
    const atEnd = index >= entries.length - 1;
    const timer = setTimeout(
      () => (atEnd ? latest.current.onDone() : latest.current.step(1)),
      atEnd ? CATCH_UP_END_MS : CATCH_UP_STEP_MS,
    );
    return () => clearTimeout(timer);
  }, [on, entries, index]);
}
